import {
  ButtonERP,
  ButtonFilterERP,
  ButtonPrimeReact,
  CalendarPrimeReact,
  SearchInput,
} from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { AsientosContablesQueryParamsPropsNew } from "api/AsientoContable.service"
import { DATE_YYYY_MM_DD } from "common/components/FilterMenu/constants"
import { formatDate } from "common/utils/utils"
import { useGlobalContext } from "context/_globals"
import { LibroDiarioAndMayorCommonProps } from "context/initialStates"
import { AnimatePresence } from "framer-motion"
import { Dialog } from "primereact/dialog"
import { Dropdown } from "primereact/dropdown"
import { InputNumber } from "primereact/inputnumber"
import { Menu } from "primereact/menu"
import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import {
  TIPO_ASIENTO_LABELS,
  TipoAsientoLabelsProps,
} from "../LibroMayor/constants/TipoAsientoLabels"

export const FilterMenu = ({
  serviceQuery,
  sortingCriteria,
  skipCount,
  maxResultCount,
  createAsiento,
  exportToExcel,
  resetPagination,
  setShowModalClosingDates,
  setShowModalCierreContable,
  selectedAsientoTipo,
  setSelectedAsientoTipo,
  keyword,
  setKeyword,
  amount,
  setAmount,
}: {
  serviceQuery: $TSMigrationFixMe
  sortingCriteria?: AsientosContablesQueryParamsPropsNew["SortingCriteria"]
  skipCount?: AsientosContablesQueryParamsPropsNew["SkipCount"]
  maxResultCount?: AsientosContablesQueryParamsPropsNew["MaxResultCount"]
  createAsiento?: () => void
  exportToExcel?: () => void
  resetPagination?: () => void
  setShowModalClosingDates?: (any: $TSMigrationFixMe) => void
  setShowModalCierreContable?: React.Dispatch<React.SetStateAction<boolean>>
  selectedAsientoTipo: TipoAsientoLabelsProps
  setSelectedAsientoTipo: React.Dispatch<
    React.SetStateAction<TipoAsientoLabelsProps>
  >
  keyword: string | undefined
  setKeyword: React.Dispatch<React.SetStateAction<string | undefined>>
  amount: { min: number | undefined; max: number | undefined }
  setAmount: React.Dispatch<
    React.SetStateAction<{ min: number | undefined; max: number | undefined }>
  >
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()
  const [contextStore, setContextStore] = useGlobalContext()
  const {
    contabilidad: { libroDiarioAndMayorCommon },
  } = contextStore
  const setLibroDiarioAndMayorCommon = (
    value: LibroDiarioAndMayorCommonProps
  ) => {
    setContextStore({
      ...contextStore,
      contabilidad: {
        ...contextStore.contabilidad,
        libroDiarioAndMayorCommon: {
          dateFilter: value?.dateFilter,
        },
      },
    })
  }
  const [menuOpen, setMenuOpen] = useState(false)

  const openFilters = () => {
    setMenuOpen(true)
  }
  const menu = useRef<Menu>(null)
  const menuOptions = [
    {
      label: `${t("mayor.exportButton")}`,
      icon: "pi pi-file-excel",
      command: exportToExcel,
    },
    {
      label: `${t("mayor.finantialClosingButton")}`,
      icon: "pi pi-check-square",
      command: () => setShowModalClosingDates?.(true),
    },
    {
      label: `${t("mayor.accountingClose")}`,
      icon: "pi pi-lock",
      command: () => setShowModalCierreContable?.(true),
    },
  ]
  const queryFixer = (queryParams: AsientosContablesQueryParamsPropsNew) => {
    const facturasParams = {
      CuentaContableGrupos: queryParams.CuentaContableGrupos,
      CuentaContableId: queryParams.CuentaContableId,
      FechaLowerLimit: queryParams.FechaLowerLimit,
      FechaUpperLimit: queryParams.FechaUpperLimit,
      ImporteLowerLimit: queryParams.ImporteLowerLimit,
      ImporteUpperLimit: queryParams.ImporteUpperLimit,
      Keyword: queryParams.Keyword,
      MaxResultCount: queryParams.MaxResultCount,
      SkipCount: queryParams.SkipCount,
      SortingCriteria:
        queryParams.SortingCriteria?.property &&
        queryParams.SortingCriteria?.sort
          ? `${queryParams.SortingCriteria.property} ${queryParams.SortingCriteria.sort}`
          : "asientoContable.Fecha DESC,asientoContable.Numero,Numero",
    }
    const fixedQueryParams = Object.fromEntries(
      Object.entries(facturasParams).filter(
        ([_key, value]) => value || value === 0 // eslint-disable-line @typescript-eslint/no-unused-vars
      )
    )
    return fixedQueryParams
  }
  const query = {
    CuentaContableGrupos: selectedAsientoTipo?.tipo,
    FechaLowerLimit:
      libroDiarioAndMayorCommon?.dateFilter &&
      libroDiarioAndMayorCommon?.dateFilter[0]
        ? formatDate(libroDiarioAndMayorCommon?.dateFilter[0], DATE_YYYY_MM_DD)
        : "",
    FechaUpperLimit:
      libroDiarioAndMayorCommon?.dateFilter &&
      libroDiarioAndMayorCommon?.dateFilter[1]
        ? formatDate(libroDiarioAndMayorCommon?.dateFilter[1], DATE_YYYY_MM_DD)
        : "",
    ImporteLowerLimit: amount.min,
    ImporteUpperLimit: amount.max,
    SortingCriteria: sortingCriteria,
    SkipCount: skipCount,
    MaxResultCount: maxResultCount,
    Keyword: keyword,
  }
  const handleQuery = () => {
    serviceQuery(queryFixer(query))
  }
  const handleApplyFilters = () => {
    setMenuOpen(false)
  }
  const hideFilter = () => {
    setMenuOpen(!menuOpen)
  }
  const handleResetFilters = () => {
    serviceQuery(
      queryFixer({
        FechaLowerLimit:
          libroDiarioAndMayorCommon?.dateFilter &&
          libroDiarioAndMayorCommon?.dateFilter[0]
            ? formatDate(libroDiarioAndMayorCommon?.dateFilter[0], "DD-MM-YYYY")
            : "",
        FechaUpperLimit:
          libroDiarioAndMayorCommon?.dateFilter &&
          libroDiarioAndMayorCommon?.dateFilter[1]
            ? formatDate(libroDiarioAndMayorCommon?.dateFilter[1], "DD-MM-YYYY")
            : "",
      })
    )
    setSelectedAsientoTipo(TIPO_ASIENTO_LABELS(t)[0])
    setAmount({ min: undefined, max: undefined })
  }

  const appliedFiltersTags = [
    {
      label: t("filtros.appliedTag.typeLabel"),
      value:
        selectedAsientoTipo.descripcion &&
        selectedAsientoTipo.descripcion ===
          TIPO_ASIENTO_LABELS(t)[0].descripcion
          ? undefined
          : selectedAsientoTipo.descripcion,
      action: () => setSelectedAsientoTipo(TIPO_ASIENTO_LABELS(t)[0]),
    },
    {
      label: t("filtros.appliedTag.amountFrom"),
      value: amount?.min
        ? Intl.NumberFormat("de-DE", {
            style: "currency",
            currency: "EUR",
          }).format(amount?.min)
        : undefined,
      action: () => setAmount({ ...amount, min: undefined }),
    },
    {
      label: t("filtros.appliedTag.amountTo"),
      value: amount?.max
        ? Intl.NumberFormat("de-DE", {
            style: "currency",
            currency: "EUR",
          }).format(amount?.max)
        : undefined,
      action: () => setAmount({ ...amount, max: undefined }),
    },
  ]
  const appliedFilters = appliedFiltersTags.filter((filter) => filter.value)

  useEffect(() => {
    resetPagination?.()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    // FIX: Se reinicia la paginacion y el ordenamiento al cambiar de pagina pero el sorter aparece activo
    keyword,
    libroDiarioAndMayorCommon?.dateFilter,
    appliedFilters?.length,
  ])

  useEffect(() => {
    handleQuery()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    libroDiarioAndMayorCommon?.dateFilter,
    selectedAsientoTipo,
    keyword,
    amount?.min,
    amount?.max,
    sortingCriteria?.sort,
    sortingCriteria?.property,
    skipCount,
    maxResultCount,
  ])

  return (
    <>
      <div className='!tw-px-6 tw-flex tw-flex-row tw-justify-between tw-items-center tw-pb-4 tw-pt-6 tw-shadow-3xl tw-rounded-t-xl mb-1 tw-bg-white tw-relative'>
        <p className='tw-my-0 tw-whitespace-nowrap tw-text-xl tw-text-text tw-flex tw-items-center tw-gap-2'>
          {t("diario.title")}
        </p>

        <div className='tw-flex tw-flex-wrap tw-items-center tw-justify-end tw-gap-2 tw-w-full xl:tw-w-auto'>
          <div className='tw-flex-shrink-0'>
            <ButtonFilterERP
              isActive={appliedFilters.length > 0}
              numberActive={appliedFilters?.length}
              onClick={openFilters}
              deleteFilter={handleResetFilters}
              filterButtonLabel={`${t("filtros.title")}`}
            />
          </div>
          <div className='calendar-container tw-relative tw-flex-shrink-0'>
            {libroDiarioAndMayorCommon?.dateFilter && (
              <FontAwesomeIcon
                icon={["fal", "calendar-lines"]}
                className='!tw-absolute tw-text-simple-10 tw-top-2 tw-left-6 tw-h-5 tw-z-10 tw-cursor-pointer tw-pt-0.5'
              />
            )}
            <CalendarPrimeReact
              value={libroDiarioAndMayorCommon?.dateFilter}
              selectionMode='range'
              locale={language}
              dateFormat='dd/mm/yy'
              className={`${
                libroDiarioAndMayorCommon?.dateFilter && "calendar-selected"
              }`}
              onChange={({ value }) => {
                if (value) {
                  setLibroDiarioAndMayorCommon({
                    dateFilter: value as Date[],
                  })
                  resetPagination?.()
                }
              }}
              readOnlyInput
              showIcon={!libroDiarioAndMayorCommon?.dateFilter}
            />

            {libroDiarioAndMayorCommon?.dateFilter && (
              <FontAwesomeIcon
                icon={["fal", "xmark"]}
                className='!tw-absolute tw-top-2 tw-right-6 tw-text-simple-10 tw-h-4 tw-w-4 tw-cursor-pointer !tw-pt-1'
                onClick={() => {
                  setLibroDiarioAndMayorCommon({
                    dateFilter: undefined,
                  })
                  resetPagination?.()
                }}
              />
            )}
          </div>
          <div className='tw-flex-shrink tw-w-72'>
            <SearchInput
              placeholder={`${t("validaciones.placeholderSearch")}`}
              onChange={(ev: string) => {
                resetPagination?.()
                setKeyword(ev)
              }}
              inputValue={keyword}
              className='tw-mb-1 sm:tw-mb-0 sm:tw-mr-2 tw-h-10 tw-w-full 2xl:tw-w-72'
            />
          </div>
          <div className='tw-flex tw-items-center tw-gap-2 tw-flex-shrink-0'>
            <ButtonERP
              customize={{
                size: "md",
                type: "secondary",
              }}
              onClick={createAsiento}
              label={`${t("mayor.addEntry")}`}
            />
            <div className='tw-place-content-center tw-border-solid tw-border tw-rounded-md xl:tw-max-w-10 hover:!tw-bg-gray-100 tw-select-none'>
              <Menu
                popup
                ref={menu}
                id='popup_menu_libro_diario'
                className='!tw-py-1'
                model={menuOptions}
              />
              <div
                className='tw-place-content-center tw-cursor-pointer tw-size-10 tw-rounded-md'
                onClick={(event) => menu.current?.toggle(event)}
                aria-controls='popup_menu_libro_diario'
                aria-haspopup
              >
                <FontAwesomeIcon
                  icon={["fal", "ellipsis-v"]}
                  aria-controls='popup_menu_libro_diario'
                  aria-haspopup
                  className='tw-text-black tw-size-5'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <AnimatePresence>
        <Dialog
          breakpoints={{ "960px": "75vw" }}
          className='p-dialog-right tw-select-none'
          header={t("filtros.title")}
          visible={menuOpen}
          footer={
            <div className='tw-w-full tw-border-t-2 tw-pt-6'>
              <ButtonPrimeReact
                className='tw-ml-2 !tw-bg-primary tw-cursor-pointer !tw-w-full'
                onClick={handleApplyFilters}
              >
                {t("filtros.labelApply")}
              </ButtonPrimeReact>
            </div>
          }
          onHide={() => {
            hideFilter()
          }}
          draggable={false}
          resizable={false}
          position='right'
          closable
          closeOnEscape
        >
          {!!appliedFilters?.length && (
            <div className='tw-mb-8'>
              <div className='flex tw- tw-mb-4 tw-justify-between'>
                <span className='tw-font-medium'>
                  {t("tickets.filter.appliedFilters")}
                </span>
                <span
                  onClick={handleResetFilters}
                  className='tw-text-text-hyperlinks tw-cursor-pointer'
                >
                  {t("tickets.filter.deleteAll")}
                </span>
              </div>
              <div className='tw-flex tw-flex-wrap tw-mb-8 tw-gap-2 tw-font-normal tw-text-xs'>
                {appliedFilters.map((filter) => (
                  <div
                    key={filter.label}
                    onClick={filter.action}
                    className='tw-items-center tw-justify-between tw-cursor-pointer tw-bg-info-10 tw-text-info tw-rounded-md tw-border tw-border-info tw-py-1 tw-px-2'
                  >
                    <span>
                      {filter.label} {filter.value}
                    </span>
                    <FontAwesomeIcon
                      icon={["fal", "xmark"]}
                      className='tw-ml-2 tw-text-info'
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
          <div className='tw-mb-8'>
            <div className='tw-mb-2'>
              <span className='tw-font-medium'>{t("TIPOS")}</span>
            </div>
            <Dropdown
              value={selectedAsientoTipo}
              options={TIPO_ASIENTO_LABELS(t)}
              optionLabel='descripcion'
              onChange={(e) => setSelectedAsientoTipo(e.value)}
              className='mt-2 w-100'
              panelClassName='!tw-z-[2302]'
            />
          </div>

          <div className='tw-mb-8'>
            <div className='tw-mb-4'>
              <span className='tw-font-medium'>
                {t("filtros.importe.title")}
              </span>
            </div>
            <div className='tw-flex tw-flex-row tw-mb-8'>
              <div className='tw-flex tw-flex-col'>
                <label>
                  {t("bancos.conciliacion.filterMenu.amountLabelSince")}
                </label>
                <InputNumber
                  className='[&_input]:!tw-w-36 !tw-w-36'
                  value={amount?.min}
                  placeholder='0,00 €'
                  onValueChange={(e) => setAmount({ ...amount, min: e.value })}
                  minFractionDigits={2}
                  min={0}
                  max={amount?.max ? amount.max - 1 : Number.MAX_SAFE_INTEGER}
                  mode='currency'
                  currency='EUR'
                />
              </div>
              <div className='tw-py-3 tw-px-6 tw-items-baseline tw-mt-auto tw-mb-0'>
                -
              </div>
              <div className='tw-flex tw-flex-col'>
                <label>
                  {t("bancos.conciliacion.filterMenu.amountLabelUntil")}
                </label>
                <InputNumber
                  className='[&_input]:!tw-w-36 !tw-w-36'
                  value={amount?.max}
                  placeholder='0,00 €'
                  onValueChange={(e) => {
                    setAmount({ ...amount, max: e.value })
                  }}
                  minFractionDigits={2}
                  min={amount?.min ?? 0}
                  max={Number.MAX_SAFE_INTEGER}
                  mode='currency'
                  currency='EUR'
                />
              </div>
            </div>
          </div>
        </Dialog>
      </AnimatePresence>
    </>
  )
}
